/* eslint-disable no-process-env */
import firebase from 'firebase/compat/app';

export default function initializeFirebase(): void {
  if (firebase.apps.length !== 0) {
    return;
  }

  const firebaseConfig = {
    apiKey: (process as any).serializedEnv.FIREBASE_API_KEY,
    authDomain: (process as any).serializedEnv.FIREBASE_AUTH_DOMAIN,
    databaseURL: (process as any).serializedEnv.FIREBASE_DATABASE_URL,
    projectId: (process as any).serializedEnv.FIREBASE_PROJECT_ID,
    appId: (process as any).serializedEnv.FIREBASE_APP_ID,
    measurementId: (process as any).serializedEnv.FIREBASE_MEASUREMENT_ID,
  };
  firebase.initializeApp(firebaseConfig);
}
